import {Pipe, PipeTransform} from '@angular/core';
import {CommunicationDto} from '../../Models/Communication/communication.interface';
import {CommunicationTypesEnum} from '../../Shared/Enum/communication-types.enum';

@Pipe({
  name: 'communication',
  standalone: false
})
export class CommunicationPipe implements PipeTransform {

  transform(items: CommunicationDto[], filters: { type?: number[], breakdownType?: number }): CommunicationDto[] {

    if (!items || items.length === 0) {
      return [];
    }

    if (filters?.type?.length) {
      items = items.filter((item) => filters.type?.includes(item.id_subtipo));
    }

    if (filters.breakdownType && filters.type?.includes(CommunicationTypesEnum.breakdowns)) {
      items = items.filter((item) => item.id_tipo_averia === filters.breakdownType);
    }

    return items;

  }

}
